/* import __COLOCATED_TEMPLATE__ from './get-in-touch.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();